<template>
    <el-form
        :model="form"
        :rules="rules"
        ref="memberForm"
        size="small"
        label-width="130px">
        <!-- 选择等级 -->
        <slot name="character"
            :form="form">
        </slot>
        <!-- ID：仅在修改时 -->
        <slot name="memberId"
            :uId="form.u_id">
        </slot>
        <!-- 登录名：添加为可修改，修改为禁止修改 -->
        <slot name="uName"
            :form="form">
        </slot>
        <!-- 密码：add/change状态验证函数不一样 -->
        <slot name="password"
            :form="form">
        </slot>
        <!-- 邮箱 -->
       <el-form-item
            :label="$t('message.cmember.form5')"
            prop="email">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="center-member-email-tips">
                    <li>{{$t("public.emailTips")}}</li>
                </ul>
                <el-input 
                    type="textarea"
                    v-model="form.email"
                    slot="reference"
                    autosize
                    class="member-form-input">
                </el-input>
            </el-popover>
        </el-form-item>
		
        <!-- 联络人姓名 -->
        <el-form-item
            :label="$t('message.cmember.form6')">
            <el-input
                v-model="form.truename"
                class="member-form-input"
                clearable>
            </el-input>
        </el-form-item>
		<!-- 员工编号 -->
		<el-form-item
		    :label="$t('message.cmember.form23')">
		    <el-input
		        v-model="form.personal_sn"
		        class="member-form-input"
		        clearable>
		    </el-input>
		</el-form-item>
        <!-- 所属市场 -->
        <el-form-item
            :label="$t('message.cmember.form7')">
            <el-select
                v-model="form.market">
                <el-option
                    v-for="(item, index) in markets"
                    :key="index"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 所属公司 -->
        <el-form-item
            :label="$t('message.cmember.form8')">
            <el-select
                v-model="form.branch_id"
                @change="handleSelectCompany">
                <el-option
                    v-for="(item, index) in dataCompany"
                    :key="index"
                    :label="item.branchname"
                    :value="item.branch_id">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 所属部门 -->
        <el-form-item
            :label="$t('message.cmember.form9')">
            <el-select
                v-model="form.department_id"
                @change="handleSelectDepartment">
                <el-option
                    v-for="(item, index) in dataDepartment"
                    :key="index"
                    :label="item.departmentname"
                    :value="item.department_id">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 权限 -->
        <el-form-item
            :label="$t('message.cmember.form10')"
            v-if="form.character_id != 6">
            <!-- 全选 -->
           <el-checkbox
                :indeterminate="powerIndeterminate"
                v-model="powerAll"
                @change="handlePowerCheckAll">
                <span>{{$t("message.cmember.checkAll")}}</span>
            </el-checkbox>
            <!-- 选项 菜單-->
			<div>
				<div>菜單</div>
				<el-checkbox-group
				    v-model="form.powers"
				    class="member-form-checkbox-group">
					<el-checkbox
					    v-for="(item, index) in power_options.slice(0, 16)"
					    :key="index"
					    :label="item.power_id">
					    <span>{{item.power_name}}</span>
					</el-checkbox>
				</el-checkbox-group>	
			</div>
			<!-- 选项 功能-->
			<div>
				<div>功能</div>
				<el-checkbox-group
				    v-model="form.powers"
				    class="member-form-checkbox-group">
					<el-checkbox
					    v-for="(item, index) in power_options.slice(16,23)"
					    :key="index"
					    :label="item.power_id">
					    <span>{{item.power_name}}</span>
					</el-checkbox>
				</el-checkbox-group>
			</div>
        </el-form-item>
        <!-- 已选地址 -->
        <slot name="selectedAddress"
            :form="form">
        </slot>
        <!-- 选择地址 -->
        <el-form-item
            :label="$t('message.cmember.form12')"
            v-if="[2,3].includes(form.character_id)">
            <slot name="addressRemark"></slot>
            <el-table
			    ref="fileTable" 
                :data="dataAddress"
                max-height='200'
                tooltip-effect="dark"
                @selection-change="handleSelectAddress">
                <!-- 多选框 -->
                <el-table-column
                    type="selection"
                    align="center"
                    width="40">
                </el-table-column>
                <!-- 姓名 -->
                <el-table-column
                    :label="$t('message.cmember.address1')"
                    prop="consignee"
                    width="250"
                    show-overflow-tooltip>
                </el-table-column>
                <!-- 地址 -->
                <el-table-column
                    :label="$t('message.cmember.address2')"
                    prop="address"
                    show-overflow-tooltip>
                </el-table-column>
            </el-table>
        </el-form-item>
        <!-- 报价单审批 -->
        <el-form-item
			v-if="form.powers.includes(7)|| form.character_id==2"
            :label="$t('message.cmember.form22')">
            <!-- 单选框 -->
            <el-radio-group
                v-model="form.quote_status"
				@change="handleAssign(form.quote_status==1 || form.order_status==1?true:false)">
                <el-radio :label="1">
                    <span>{{$t("public.radio1")}}</span>
                </el-radio>
                <el-radio :label="0">
                    <span>{{$t("public.radio2")}}</span>
                </el-radio>
            </el-radio-group>
        </el-form-item>
		<!-- 订单指定审批 -->
		<el-form-item
			 v-if="form.powers.includes(7)  ||form.character_id==2"
		    :label="$t('message.cmember.form16')">
		    <!-- 单选框 -->
		    <el-radio-group
		        v-model="form.order_status"
		        @change="handleAssign(form.quote_status==1 || form.order_status==1?true:false)">
		        <el-radio :label="1">{{$t("public.radio1")}}</el-radio>
		        <el-radio :label="0">{{$t("public.radio2")}}</el-radio>
		    </el-radio-group>
		    <!-- 穿梭框 -->
		    <el-transfer 
		        v-model="form.flow" 
		        :data="dataExamine"
		        :props="{
		            key: 'id',
		            label: 'username'
		        }"
		        :titles="[$t('message.cmember.transfer1'),$t('message.cmember.transfer2')]"
		        v-if="form.order_status ||  form.quote_status"
		        @change="handleTransfer"
		        target-order="push">
		    </el-transfer>
		</el-form-item>
        <!-- 跨部门 -->
        <el-form-item
            :label="jurisdiction_label"
            v-if="form.character_id !== 6 && !!form.character_id">
            <!-- 单选框 -->
            <el-radio-group
                v-model="needCross"
                v-if="[3,4].includes(form.character_id)">
                <el-radio :label="true">
                    <span>{{$t("public.radio1")}}</span>
                </el-radio>
                <el-radio :label="false">
                    <span>{{$t("public.radio2")}}</span>
                </el-radio>
            </el-radio-group>
            <!-- 跨部门列表 -->
			 <!-- v-if="needCross || form.character_id == 2" -->
            <template>
                <!-- :render-content="renderContent" -->
                <el-tree
                    :data="dataJurisdiction"
                    ref="tree"
                    node-key="nodeKey"
                    :props="{
                        children: 'department'
                    }"
                    highlight-current
                    show-checkbox
                    accordion
                    default-expand-all
                    :default-checked-keys="checkedJur"
                    @check="handleCheckChange"
                    class="form-tree">
                    <template #default="{ data }">
                        <div class="tree-title">
                            {{data.branchname || data.departmentname}}
                        </div>
                    </template>
                </el-tree>
            </template>
        </el-form-item>
        <!-- 审批 & 金额 -->
        <template v-if="form.powers.includes(7) || form.character_id == 6">
            <!-- 超出需审批金额 -->
            <el-form-item
                :label="$t('message.cmember.form17')"
                v-if="form.order_status==1&& form.powers.includes(7)">
                <el-input
                    v-model="form.limit_exceed"
                    type="number"
                    min="0"
                    class="member-form-input"
                    clearable>
                </el-input>
                <span class="member-form-input-remarks">{{$t("message.cmember.exceedRemarks")}}</span>
            </el-form-item>
            <!-- 限制金额 最高 -->
            <el-form-item
                :label="$t('message.cmember.form18')"
                prop=""
                v-if="form.powers.includes(7)">
                <el-input
                    v-model="form.limit_amount"
                    type="number"
                    min="0"
                    class="member-form-input"
                    clearable>
                </el-input>
                <div class="member-form-input-remarks">
                    {{$t("message.cmember.remark")}}
                </div>
            </el-form-item>
			<!-- 限制金额 最低-->
			<el-form-item
			    :label="$t('message.cmember.form24')"
			    prop=""
			    v-if="form.powers.includes(7)">
			    <el-input
			        v-model="form.limit_min_amount"
			        type="number"
			        min="0"
			        class="member-form-input"
			        clearable>
			    </el-input>
		<!-- 	    <div class="member-form-input-remarks">
			        {{$t("message.cmember.remark2")}}
			    </div> -->
			</el-form-item>
            <!-- 月限制金额 -->
            <el-form-item
                :label="$t('message.cmember.form19')"
                prop="">
                <el-row>
                    <el-col 
                        :span="2" 
                        v-for="(value, key, index) in form.limit_month" 
                        :key="index">
                        <div class="member-form-limit-month-title">{{$t(`message.cmember.month${index+1}`)}}</div>
                        <el-input
                            v-model="form.limit_month[key]"
                            type="number"
                            min="0"
                            class="member-form-limit-month-input">
                        </el-input>
                    </el-col>
                </el-row>
                <!-- <div class="member-form-input-remarks" v-if="dataBalance!==''">
                    {{$t("public.remarks",{balance:dataBalance})}}
                </div> -->
				<div class="member-form-input-remarks" v-if="dataBalance!==''">
				     剩餘可分配額度：{{dataBalance2}}
				</div>
            </el-form-item>
            <!-- 是否开启累计金额 -->
            <el-form-item
                :label="$t('message.cmember.form20')">
                <el-switch
                    v-model="form.accumulative_type"
                    :active-text="form.accumulative_type?$t('public.radio1'):$t('public.radio2')">
                </el-switch>
            </el-form-item>
        </template>
        <!-- 添加按钮 -->
        <el-form-item>
            <slot name="submit"
                :form="form"
                :rule="$refs">
            </slot>
        </el-form-item>
    </el-form>
</template>

<script>
import { uname, pwd, cpwd, code, update_pwd, email } from "@/utils/validate";
import { regions, member } from "@/utils/staticData";

export default {
    mixins: [ regions, member ],
    data() {
        let validateUname = (rule, value, callback) => { // 用户名验证
            uname(this, rule, value, callback);
        },
        validatepwd = (rule, value, callback) => { // 密码验证
            pwd(this, "memberForm", rule, value, callback);
        },
        validateUpdatePwd = (rule, value, callback) => {
            update_pwd(this, "memberForm", rule, value, callback);
        },
        validateEmail = (rule, value, callback) => {
            email(this, true, value, callback);
        }
        return {
			aCombination:0,//总额度
			dataBalance2:0,//实时计算金额
			defaultAddress:[],//默认地址
            form: { // 表单
				order_status:0,
				personal_sn:'',
                character_id: '',
                u_id: '',
                u_name: '',
                pwd: '',
                email: '',
                truename: '',
                market: '',
                branch_id: '',
                department_id: '',
                powers: [],
                address: [],
                quote_status: 0,
                jurisdiction: [],
                flow: [],
                limit_exceed: '',
				limit_min_amount:'',
                limit_amount: '',
                limit_month: {
                    January:'',
                    February:'',
                    March:'',
                    April:'',
                    May:'',
                    June:'',
                    July:'',
                    August:'',
                    September:'',
                    October:'',
                    November:'',
                    December:''
                },
                accumulative_type: false,
				
            },
            rules: {
                character_id: [
                    { required: true, message: "请选择用户等级", trigger: 'blur' },
                ],
                u_name:[
                    { required: true, validator: validateUname, trigger: [ 'blur', 'change' ] },
                ],
                pwd: [
                    { required: true, validator: validatepwd, trigger: 'blur' }
                ],
                up_pwd: [
                    { required: false, validator: validateUpdatePwd, trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: validateEmail, trigger: ['blur', 'change'] }
                ],
            },

            powerAll: false, // 权限全选绑定值
            powerIndeterminate: false, // 权限非全选但有值状态

            jurisdiction_label: "", // 跨部门标题
            checkedJur: [], // 默认选中的跨部门node-key列表
            needCross: false, // 是否需要跨部门打单
            needAssign: false, // 是否需要指定审批人
        }
    },
    props: {
        memberDetail: {
            type: Object,
            default: () => { return {} }
        },
        dataCharacter: Array,
        dataCompany: Array,
        dataDepartment: Array,
        dataAddress: Array,
        dataExamine: Array,
        dataJurisdiction: Array,
        dataBalance: [String, Number],
        handleValidateUname: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        markets(){
            let lang = localStorage.lang,
            markets = this.cn_type;
            if(lang == "en"){
                markets = this.en_type;
            }
            return markets
        }
    },
    components: {
        memberFormCheckbox: () => import("@/components/center/memberFormCheckbox")
    },
    watch: {
		dataBalance(){
			// console.log(this.dataBalance)
			this.aCombination = this.dataBalance
		},
		　form: {
		　　　handler(newValue, oldValue) {
				let data = Number(newValue.limit_month.April) + Number(newValue.limit_month.August) + Number(newValue.limit_month.December) + Number(newValue.limit_month.February) + Number(newValue.limit_month.January) + Number(newValue.limit_month.July) + Number(newValue.limit_month.June) + Number(newValue.limit_month.March)+ Number(newValue.limit_month.May)+Number(newValue.limit_month.November)+Number(newValue.limit_month.October)+Number(newValue.limit_month.September)
				this.dataBalance2 =  Number(this.aCombination) - Number(data);
				// console.log(this.aCombination,data,this.dataBalance2)
				// console.log(this.aCombination,data)
			},
		　　deep: true
		},
        memberDetail: {
            handler: function(value) {
                if(JSON.stringify(value) === '{}') return;
                let {
					personal_sn = '',
                    character_id = '',
                    user_id: u_id = '',
                    username: u_name = '',
                    pwd = '',
                    email = '',
                    truename = '',
                    market = '',
                    branch_id = '',
                    department_id = '',
                    powers = [],
                    quote_status = 0,
                    jurisdiction = [],
                    flow = [],
                    flow_id = '',
                    approval_amount: limit_exceed = '',
					limit_min_amount = '',
                    limit_amount = '',
                    monthly_amount: limit_month = {
                        January:'',
                        February:'',
                        March:'',
                        April:'',
                        May:'',
                        June:'',
                        July:'',
                        August:'',
                        September:'',
                        October:'',
                        November:'',
                        December:''
                    },
                    accumulative_type,
					order_status
                } = value;
	

                // 触发公司数据选择，获取部门列表（必须在form前面触发）
                this.handleSelectCompany(branch_id);
                // 判断是否存在审批
                this.needAssign = flow.length > 0? true: false;
                // 判断是否存在跨部门数据
                this.needCross = jurisdiction.length > 0? true: false;
                // 写入默认勾选的跨部门数据
                this.checkedJur = this.handleDefaultChecked(jurisdiction);
				this.defaultAddress = value.address;
                this.form = {
					personal_sn,
                    character_id,
                    u_id,
                    u_name,
                    pwd,
                    email,
                    truename,
                    market,
                    branch_id,
                    department_id,
                    powers,
                    address:[],
                    quote_status,
                    jurisdiction,
                    flow,
                    flow_id,
                    limit_exceed,
					limit_min_amount,
                    limit_amount,
                    limit_month,
                    accumulative_type: accumulative_type == '1'? true: false,
					order_status,
                }
				let a =	Number(this.form.limit_month.April) + Number(this.form.limit_month.August) + Number(this.form.limit_month.December) + Number(this.form.limit_month.February) + Number(this.form.limit_month.January) + Number(this.form.limit_month.July) + Number(this.form.limit_month.June) + Number(this.form.limit_month.March)+ Number(this.form.limit_month.May)+Number(this.form.limit_month.November)+Number(this.form.limit_month.October)+Number(this.form.limit_month.September) || 0;
				this.aCombination = a + Number(this.dataBalance);
				// console.log(this.aCombination,a,this.dataBalance)
				
		　　　　 
            },
			
            immediate: true,
			
        },
        'form.character_id': { // 监听角色选择，初始化表单
            handler: function(value) {
				
                let label = '', radio = false, power = [];
                switch (value){
                    case 2:
                        label = this.$t("message.cmember.form13");
                        radio = true;
                        break;
                    case 3:
                        label = this.$t("message.cmember.form14");
                        !this.form.powers.includes(7) && power.push(7)
                        break;
                    case 4:
                        label = this.$t("message.cmember.form15");
                        break;
                    case 5:
                        label = this.$t("message.cmember.form13");
                        radio = true;
                        break;
                    case 6:
                        !this.form.powers.includes(4) && power.push(4)
                        break;
                }

                this.jurisdiction_label = label;
                // 当存在角色id时，为修改表单，此处不需要重写power和needCross
                if(!this.memberDetail.character_id){
                    this.needCross = radio;
                    this.form.powers = power;
                }
            },
            immediate: true
        },
        'form.powers': {
            handler: function(value) {
                let count = value.length,
                    opLength = this.power_options.length;
                this.powerAll = count === opLength;
                this.powerIndeterminate = count> 0 && count < opLength;
            },
            immediate: true
        }
    },
	mounted() {
		console.log("查看",this.dataAddress)
		this.AddressToAdd();
	},
    methods: {
		//默认选中地址
		AddressToAdd(){
			if(this.defaultAddress.length>0){
				let address = this.Arrayjudgment();
				for (let i = 0; i < address.length; i++) {
				     this.$refs.fileTable.toggleRowSelection(address[i])
				   }	
			}
		},
		//判断是否符合条件
		filterData(data,params1,params2) {
			let _data = data.filter(item => item.address === params1 && item.consignee === params2)
			return _data.length>0?true:false
		},
		//过滤符合条件的数组出来
		Arrayjudgment(){
			let _data = this.dataAddress.filter(item =>  this.filterData(this.defaultAddress,item['address'],item['consignee'] ))
			return _data
		},
		
        handleDefaultChecked(list) { // 计算跨部门默认选中项
            let arr = [],
                data = this.dataJurisdiction;

            if(list.length === 0) return arr;
            
            data[0].department.map(bItem => {
                list.map(item => {
                    if(bItem.department.length > 0){
                        bItem.department.map(dItem => {
                            if(item.department_id == dItem.department_id){
                                arr.push(dItem.nodeKey);
                                return ;
                            }
                        })
                    }else{
                        if(item.branch_id == bItem.branch_id){
                            arr.push(bItem.nodeKey);
                            return
                        }
                    }
                })
            })
            return arr;
        },
        handleCheckChange(data, checked) { // 写入选中跨部门数据
            let { checkedNodes } = checked;
            let arr = [];
            checkedNodes.map((item, index) => {
                if(!item.department){
                    arr.push(item)
                }else if (JSON.stringify(item.department) == '[]'){
                    item.department_id = 0;
                    arr.push(item)
                }
            })
            this.form.jurisdiction = arr;
        },
        handleSelectCompany(value){ // 所属公司更改时
            let id = this.memberDetail.id,
                d_id = this.memberDetail.department_id || this.form.department_id,
                character_id = this.memberDetail.character_id || this.form.character_id,
                department_id = d_id? d_id: '',
                user_id = id? id: '';
            
            this.form.department_id = "";
            // this.needAssign = false;
			this.form.order_status=0;
            this.handleAssign(false);
            this.$emit('selected-company', character_id, value, department_id, user_id)
        },
        handleSelectDepartment(department_id){ // 所属部门更改时
            let id = this.memberDetail.id,
                user_id = id? id: '';
            // this.needAssign = false;
			this.form.order_status=0;
            this.handleAssign(false);
            this.$emit('selected-department', this.form.character_id, this.form.branch_id, department_id, user_id);
        },
        handleSelectAddress(addressList){ // 地址选中写入
            this.form.address = addressList;
        },
        // 权限power
        handlePowerCheckAll(value) { // 全选操作
            let power = [];
            if(value){
                this.power_options.map(item => {
                    power.push(item.power_id);
                })
            }
            this.form.powers = power;
            this.powerIndeterminate = false;
        },
        handleAssign(need){  // 指定审批人单选框
		// console.log("查看一下",need)
            let id = this.memberDetail.id,
                user_id = id? id: '';
            if(!this.form.character_id && need){
                this.$message({
                    showClose: true,
                    message: this.$t("message.cmember.errmsg1"),
                    type: "warning"
                })
                // this.needAssign = false;
				this.form.order_status=0;
                return
            }
            if(!need) {
                this.form.flow = [];
                this.handleTransfer();
            }
            this.$emit('handle-assign', this.form.character_id, this.form.branch_id, this.form.department_id, user_id, need);
        },
        handleTransfer(){ // 指定审批人更改时（修改时生效）
            let data = this.memberDetail;
            if(JSON.stringify(data) !== '{}'){
                this.form.flow_id = data.flow_id === ""? 0: data.flow_id;
            }
        }
    }
}
</script>

<style scoped>
/* 注册提示弹出框 */
.member-form-popover{
    list-style-type: circle;
    padding-left: 20px;
}
/* 跨部门分公司全选 */
.member-form-jurisdiction-all{
    margin: 10px 0;
}
.member-form-jurisdiction-all>>>.el-checkbox__label{
    font-size: 18px;
    font-weight: bold;
}
.center-member-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
/* 输入框 */
/* .member-form-input{
    width: 200px;
} */
/* 多选框 */
.member-form-checkbox-group>.el-checkbox+.el-checkbox{
    margin-left: 0;
}
/* 输入框后备注 */
.member-form-input-remarks{
    margin-left:10px;
    color:#909399;
}
/* 月限制金额标题 */
.member-form-limit-month-title{
    text-align: center;
}
/* 月限制金额输入框 */
.member-form-limit-month-input>>>input{
    padding: 0 5px;
}
.form-tree >>> .tree-title{
    font-weight: bold;
}
</style>